import { createNamespacer, createReducer } from "../utils/reducers";

const namespacer = createNamespacer("SEARCH");

const initialState = {
  openChatBot: false,
  searchText: "",
  topProviders: [],
  topPlanners: [],
};

const handlers = {
  [namespacer("SET_CHAT_BOAT_MESSAGE")]: (state: any, action: any) => {
    return {
      ...state,
      openChatBot: action.payload?.openChatBot,
      searchText:  action.payload?.searchText,
    };
  },
  [namespacer("SET_TOP_PARTNER")]: (state: any, action: any) => {
    return {
      ...state,
      topProviders: action.payload?.topProviders,
      topPlanners:  action.payload?.topPlanners,
    };
  },
};

const search = createReducer(initialState, handlers, ["SEARCH"]);

export default search;
